import PropTypes from "prop-types";
import { InputMask } from "@react-input/mask";
import { forwardRef } from "react";

const MaskComponent = forwardRef(function MaskComponent(props, ref) {
  return <InputMask ref={ref} {...props} />;
});

MaskComponent.propTypes = {
  inputRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.element }),
  ]),
};

export default MaskComponent;
